import React, { useEffect, useRef, useState } from 'react';
import nvgtrBM from '../../../assets/nvgtr_BM.svg';
import nvgtrBMWhite from '../../../assets/nvgtr_BM_white.svg';
import { useTheme } from '../../theme/context/ThemeContext';

export const GreetingComponentV2 = ({ user }) => {
  const { darkMode } = useTheme();
  const fontFamilyStyle = { fontFamily: 'var(--chat-font-family)' };
  const currentHour = new Date().getHours();
  let greeting = "Morning";
  
  if (currentHour >= 12 && currentHour < 17) {
    greeting = "Afternoon";
  } else if (currentHour >= 17) {
    greeting = "Evening";
  }

  // Try different possible property names, prioritizing preferred name
  const firstName = user?.preferredName || user?.preferred_name || user?.displayName || user?.display_name || user?.nickname || user?.firstName || user?.first_name || user?.name?.split(' ')[0] || '---';
  const fullText = `${greeting}, ${firstName}.`;
  
  // Only show typing animation when we have real user data (not the fallback)
  const hasRealUserData = firstName !== '---';
  
  const [textWidth, setTextWidth] = useState(0);
  const measureRef = useRef(null);

  // Measure the full text width on mount
  useEffect(() => {
    if (measureRef.current) {
      setTextWidth(measureRef.current.offsetWidth);
    }
  }, [fullText]);

  return (
    <div className="flex flex-col items-center justify-center overflow-hidden">
      <style jsx>{`
        .typing-text-no-cursor {
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          border-right: 2px solid transparent;
          width: 0;
          padding-right: 1px;
          animation: 
            typing-delayed 1.5s steps(${fullText.length}, end) 0.3s forwards,
            show-cursor-delayed 0.1s linear 0.3s forwards,
            blink-caret 0.75s step-end 2 ${1.8 + (fullText.length * 0.02)}s both;
        }

        @keyframes typing-delayed {
          from { width: 0 }
          to { width: calc(100% + 1px) }
        }

        @keyframes show-cursor-delayed {
          to { border-color: currentColor }
        }
      `}</style>
      
      <div className="max-w-[800px] w-full mx-auto px-4">
        <div className="flex items-center justify-center gap-4">
          {/* NVGTR Brandmark - theme-aware logo */}
          <div className="flex-shrink-0 pb-1.5">
            <img 
              src={darkMode ? nvgtrBMWhite : nvgtrBM} 
              alt="NVGTR" 
              className="w-12 h-6"
            />
          </div>
          
          {/* Hidden element to measure text width */}
          <div 
            ref={measureRef}
            className="text-2xl sm:text-3xl font-normal absolute opacity-0 pointer-events-none whitespace-nowrap"
            style={{ left: '-9999px', ...fontFamilyStyle }}
          >
            {fullText}
          </div>
          
          {/* Greeting Text with typing effect */}
          <div 
            className="text-2xl sm:text-3xl font-normal text-black dark:text-white flex justify-start opacity-0"
            style={{ 
              animation: 'fade-in-no-move 0.1s ease-out forwards',
              width: textWidth > 0 ? `${textWidth}px` : 'auto',
              ...fontFamilyStyle
            }}
          >
            {hasRealUserData ? (
              <div className="typing-container">
                <span className="typing-text-no-cursor">{fullText}</span>
              </div>
            ) : (
              <div className="typing-container">
                <span>{fullText}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}; 